var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiTooltipOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography;
    return ({
        tooltip: __assign(__assign({}, typography.body1), { padding: spacing(2, 4), color: palette.text.secondary, backgroundColor: palette.background.overlays, filter: "drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.35))" }),
        arrow: {
            color: palette.background.overlays,
        },
    });
};
//# sourceMappingURL=MuiTooltip.js.map